import React from 'react';
import { Button, HeadingText } from '@paypalcorp/pp-react';

import * as analytics from '../lib/analytics';

const FAQBanner = ({ fptiInfo, i18n }) => {
  return (
    <div className='faq-banner'>
      <HeadingText as='div' size='sm' className='faq-banner-label'>
        {i18n('label.faq-banner')}
      </HeadingText>
      <Button
        onClick={() => {
          if (fptiInfo) {
            analytics.trackLinkWithData(
              'FAQBanner',
              fptiInfo.pgrp,
              fptiInfo.page,
              {},
              'link'
            );
          }
        }}
        as='a'
        target='_blank'
        href={i18n('label.faq-href')}
        data-testid='faq-banner-button'
        size='md'
        secondary
      >
        {i18n('label.faq-button')}
      </Button>
    </div>
  );
};

export default FAQBanner;
